module.exports = __webpack_public_path__ + "img/fb.6ba9fe9c.svg";